module.exports = __webpack_public_path__ + "static/media/updateActions.3b046b81.svg";